export const DEVICE_STATUS_VALUES = [
  'stock',
  'loaned',
  'returning',
  'under_review',
  'sold',
  'damaged',
  'workshop',
] as const;

export type DeviceStatus = typeof DEVICE_STATUS_VALUES[number];
